import { NgModule } from '@angular/core';

import { DetachedRouterModule } from '@recruitee/common';
import { I18nModule } from '@recruitee/i18n';
import { RtUIModule } from '@recruitee/user-interface';

import { RtoAvatarInputComponent } from './avatar-input/avatar-input.component';
import { RtoErrorComponent } from './error-box/error-box.component';
import { RtoMultilineButtonComponent } from './multiline-button/multiline-button.component';
import { OnboardingApiService } from './onboarding-api.service';
import { RtoPasswordInputComponent } from './password-input/password-input.component';
import { RtoPhoneInputComponent } from './phone-input/phone-input.component';
import { RtoProgressBarComponent } from './progress-bar/progress-bar.component';
import { StepTemplateComponent } from './step-template/step-template.component';
import { RtoTrialInfoComponent } from './trial-info/trial-info.component';
import { RtoWelcomeImgComponent } from './welcome-img/welcome-img.component';

@NgModule({
  imports: [I18nModule, RtUIModule, DetachedRouterModule],
  providers: [OnboardingApiService],
  declarations: [
    RtoProgressBarComponent,
    RtoAvatarInputComponent,
    RtoPhoneInputComponent,
    RtoWelcomeImgComponent,
    StepTemplateComponent,
    RtoErrorComponent,
    RtoPasswordInputComponent,
    RtoMultilineButtonComponent,
    RtoTrialInfoComponent,
  ],
  exports: [
    RtoProgressBarComponent,
    RtoAvatarInputComponent,
    RtoPhoneInputComponent,
    RtoWelcomeImgComponent,
    StepTemplateComponent,
    RtoErrorComponent,
    I18nModule,
    RtUIModule,
    DetachedRouterModule,
    RtoPasswordInputComponent,
    RtoMultilineButtonComponent,
    RtoTrialInfoComponent,
  ],
})
export class OnboardingSharedModule {}
